// extracted by css-extract-rspack-plugin
export default {"menuButton":"wDkuAChspsskCKSX","menuButtonActive":"eksMuHPBjkcYl1RC","menuItem":"e3KQkTpsm4FzwiuD","menuItemActive":"Pz83ghIOBoAy79L2"};